import pkg from 'file-saver'
import {useMediaFrameElements} from '~/composables/studio/useMediaFrameElements'
import {doTickComposition} from '~/composables/studio/useMediaComposition'

const {saveAs} = pkg

const {getFrameDocument, getStageCanvas, getFrameStage, getCompositeCanvasHeight} = useMediaFrameElements()

function createCompositionCanvas(mediaFrame: HTMLIFrameElement) {
  const mediaFrameDocument = getFrameDocument(mediaFrame)
  const stageCanvas = getStageCanvas(mediaFrame)

  if (!mediaFrameDocument || !stageCanvas) {
    console.warn('No stage canvas')
    return
  }

  const c = document.createElement('canvas')
  c.width = stageCanvas.width
  c.height = getCompositeCanvasHeight(stageCanvas)

  doTickComposition(mediaFrame, c)

  return c
}

function downloadMediaScreenshot(mediaFrame: HTMLIFrameElement) {
  const mediaStage = getFrameStage(mediaFrame)

  if (!mediaStage) {
    console.warn('No media stage')
    return
  }

  mediaStage.on('tick', () => {
    createCompositionCanvas(mediaFrame)?.toBlob(function (blob: Blob | null) {
      if (blob) {
        saveAs(blob, 'screenshot.png')
      } else {
        console.warn('No blob')
      }
    })
  }, null, true)
}

export const useMediaScreenshotTool = () => {
  return {
    downloadMediaScreenshot,
  }

}